import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconSearchOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M15.877 14.806 24 22.93 22.93 24l-8.124-8.123a9 9 0 1 1 1.07-1.07m-6.863 1.708a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15" /></svg>
);
